import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { DialogService, MessageService } from "primeng/api";
import { FileUpload } from "primeng/fileupload";
import { UtilityService } from "../../shared/utility.service";
import * as _ from "underscore";

import { CAST_INTERFACE } from "../../../app/shared/service/interface/shared.interface";
import { environment } from "../../../environments/environment";
import { FILE_UPLOAD } from "../../common/constant/fileupload.constant";
import { GLOBAL_CONSTANT } from "../../common/constant/global.constant";
import { SessionService } from "../../common/services/session.service";
import { ViewerService } from "../service/api/viewer.service";
import { viewerInterface } from "../viewer.interface";

@Component({
  selector: "app-add-viewer",
  templateUrl: "./add-viewer.component.html",
  styleUrls: ["./add-viewer.component.scss"],
  providers: [MessageService, DialogService],
})
export class AddViewerComponent implements OnInit {
  viewerObj: viewerInterface;
  viewerData: any;
  SearchType: string;
  SearchToggelFlag: boolean = false;
  optionTypes: any;
  viewerStatus: any;
  editableMode: boolean = false;
  viewerId: string;
  officeData: any;
  isDisabled: boolean = false;
  genderTypes: any;
  maximunDate = new Date();
  yearRange: any;
  profilePhoto: any;
  photoFlag: boolean = false;
  rationCardData: any = [];
  selectedRationCard: any;
  errorFlag: boolean = false;
  message: string = "";
  castObj: CAST_INTERFACE;
  photo: any;
  educationType: any;
  selectedEducation: any;
  disable: boolean = false;
  //File Upload
  uploadAPI = FILE_UPLOAD.Profile_image;
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  uploadedFiles = [];
  apiBaseUrl = environment.API_BASE;
  filetype = FILE_UPLOAD.File_type;
  picture: any;
  _entityName: string = "profileImage";

  constructor(
    private viewerService: ViewerService,
    private toast: MessageService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private sessionService: SessionService,
    public dialogService: DialogService,
    private utilityService: UtilityService
  ) {
    this.viewerObj = { extraFields: {}, addressFields: {} };
    this.castObj = {};
    this.viewerObj.role = "VIEWER";
    this.viewerObj.status = true;
    this.viewerObj.smsNotification = false;
    this.viewerObj.appNotification = false;
    this.optionTypes = GLOBAL_CONSTANT.ACTIVE_INACTIVE;
    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;
    this.educationType = GLOBAL_CONSTANT.EDUCATION_TYPE;
    this.yearRange = this.utilityService.CalYearRange();
  }

  calculateAge(dob) {
    if (this.viewerObj.dob != null) {
      dob = new Date(dob.model);
      if (dob != "Invalid Date") {
        this.viewerObj.age = moment().diff(dob, "years");
        this.disable = true;
      }
    } else {
      this.viewerObj.age = 0;
    }
  }

  saveViewerData() {
    if (this.selectedEducation !== undefined) {
      this.viewerObj.education = this.selectedEducation.value;
    } else {
      this.viewerObj.education = null;
    }
    if (this.castObj.cast != undefined) {
      this.viewerObj.cast = this.castObj.cast;
    } else {
      this.viewerObj.cast = null;
    }
    if (this.castObj.subcast != undefined) {
      this.viewerObj.subcast = this.castObj.subcast;
    } else {
      this.viewerObj.subcast = null;
    }
    if (this.selectedRationCard != undefined) {
      this.viewerObj.rationCard = this.selectedRationCard["value"];
    } else {
      this.viewerObj.rationCard = null;
    }
    if (this.editableMode) {
      this.isDisabled = true;
      this.viewerService.updateViewerData(this.viewerObj).subscribe((resp) => {
        this.toast.add({
          severity: "success",
          summary: "Updated Successfully",
          detail: "viewer entry Updated successfully !!!",
        });
        setTimeout(() => {
          this.router.navigate(["/user/viewer/list"]);
        }, 1000);
      });
    } else {
      if (this.message != "EC007") {
        this.viewerService
          .createViewerData(this.viewerObj)
          .subscribe((resp) => {
            this.toast.add({
              severity: "success",
              summary: "Created Successfully",
              detail: "Viewer Created successfully !!!",
            });
            setTimeout(() => {
              this.router.navigate(["/user/viewer/list"]);
            }, 1000);
          });
      }
    }
  }

  SaveData(viewerData) {
    if (!viewerData.valid) {
    } else {
      if (this.uploadedFiles.length >= 0) {
        this.imageUpload.upload();
        this.saveViewerData();
      } 
      // else {
      //   this.viewerObj.ProfileImage = JSON.stringify(
      //     this.viewerObj.ProfileImage
      //   );
      // }
    }
  }
  saveProfile() {
    if (this.uploadedFiles.length >= 0) {
      this.imageUpload.upload();
    }
  }

  onUploadSuccess($event) {
    let d = $event.originalEvent.body.files;
    if (!this.editableMode) {
      this.viewerObj.ProfileImage = JSON.stringify(d);
    } else if (this.editableMode) {
      if (d && d.length != 0) {
        this.viewerObj.ProfileImage = JSON.stringify(d);
      } else {
        if (this.photo && this.photo != undefined) {
          this.viewerObj.ProfileImage = JSON.stringify(this.photo);
        } else {
          this.viewerObj.ProfileImage = JSON.stringify(d);
        }
      }
    }
    if (this.viewerObj.ProfileImage) {
      if (
        this.viewerObj.ProfileImage.length != 0 &&
        this.viewerObj.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this.viewerObj.ProfileImage);
        this.profilePhoto = this.photo[0].filename;
        if (this.profilePhoto.indexOf(this._entityName) > -1) {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/downloadS3?path=" +
            this.profilePhoto;
        } else {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/file2?path=" +
            this._entityName +
            `/${this.profilePhoto}`;
        }
      } 
    }
  }

  onUploadError($event) {
    this.saveViewerData();
  }

  getEditData() {
    this.isDisabled = true;
    this.editableMode = true;
    this.viewerService.getViewerEdit(this.viewerId).subscribe((viewerData) => {
      this.setData(viewerData);
    });
  }

  setData(viewerData) {
    this.viewerObj = viewerData;

    this.editableMode = true;
    this.viewerObj.dob !== null
      ? (this.viewerObj.dob = new Date(this.viewerObj.dob))
      : null;
    this.viewerObj.status == true
      ? (this.viewerStatus = "1")
      : (this.viewerStatus = "0");
    this.selectedRationCard = _.find(this.rationCardData, (a) => {
      return a.value === this.viewerObj.rationCard;
    });
    if (this.viewerObj.extraFields == null) {
      this.viewerObj.extraFields = {};
    }
    if (this.viewerObj.addressFields == null) {
      this.viewerObj.addressFields = {};
    }
    this.castObj = {
      cast: viewerData.cast,
      subcast: viewerData.subcast,
    };
    if (
      this.viewerObj.ProfileImage.length != 0 &&
      this.viewerObj.ProfileImage != "[]"
    ) {
      this.photo = JSON.parse(this.viewerObj.ProfileImage);
      this.profilePhoto = this.photo[0].filename;
      if (this.profilePhoto.indexOf(this._entityName) > -1) {
        this.picture =
          this.apiBaseUrl +
          "/file-uploader/downloadS3?path=" +
          this.profilePhoto;
      } else {
        this.picture =
          this.apiBaseUrl +
          "/file-uploader/file2?path=" +
          this._entityName +
          `/${this.profilePhoto}`;
      }
    }
    if (this.profilePhoto != null || this.profilePhoto != undefined) {
      this.photoFlag = true;
    }
    this.selectedEducation = _.find(this.educationType, (a) => {
      return a.value === this.viewerObj.education;
    });
    if (this.viewerObj.dob != null) {
      this.disable = true;
    }
  }

  searchByOption() {
    this.viewerStatus === "1"
      ? (this.viewerObj.status = true)
      : (this.viewerObj.status = false);
  }

  checkUsername(obj) {
    let data = { username: obj };
    this.viewerService.userCheck(data).subscribe(
      (res: any) => {},
      (e) => {
        if (e != undefined) {
          this.errorFlag = true;
        }
        this.message = e.error.message;
      }
    );
  }

  ngOnInit() {
    this.viewerId = this.actRoute.snapshot.paramMap.get("id");
    this.officeData = this.sessionService.getOffice();
    if (this.viewerId != null) {
      this.getEditData();
    }
  }
}
